import { useEffect } from 'react'

/**
 * 监听浏览器后退执行事件
 * @param fn
 */
export function usePopstate(fn) {
  useEffect(() => {
    window.addEventListener('popstate', fn, false)
    return () => {
      window.removeEventListener('popstate', fn)
    }
  }, [fn])
}
